'use client';

import { ProjectModel } from '@/lib/models/Project';
import ProjectDetail from '@/components/Desktop/ProjectDetail';
import ProjectMobileDetail from '@/components/Mobile/ProjectDetailMobile';
import { useIsMobile } from '@/components/DeviceContext';

interface Props {
  project: ProjectModel;
  projects: ProjectModel[];
  desktopPresetIndex: number;
}

export default function ProjectDetailPageContent({ project, projects, desktopPresetIndex }: Props) {
  const isMobile = useIsMobile();
  return isMobile
    ? <ProjectMobileDetail project={project} projects={projects} />
    : <ProjectDetail key={project.id} project={project} projects={projects} presetIndex={desktopPresetIndex} />;
}
